import { Group, Title, Text } from '@mantine/core';

export const Unauthorized = () => {
  return (
    <Group
      data-testid="unauthorized"
      align={'center'}
      display={'flex'}
      justify={'center'}
      flex={'1'}
      pt={'xl'}
      style={{
        flexDirection: 'column',
      }}
      h={'75%'}
    >
      <Title>Unauthorized Access</Title>
      <Text>Sorry, you do not have permission to access this page.</Text>
    </Group>
  );
};
